<template>
  <div id="level-card">
    <img
      :src="require('../assets/imgs/'+ grade +'/level-card-banner1.png')"
      alt
      id="level-card-banner"
    />
    <div @click="showLevelInfo" class="clickMask"></div>
    <div style="position:absolute;" class="infoicon">
      <i class="el-icon-info" style="color: rgba(255,255,255,.7);font-size: 10px;"></i>
      <br />
      <transition name="el-fade-in-linear">
        <span
          v-show="showInfo"
          style="background: rgba(255,255,255,.8);padding: 3px;font-size: 10px;border-radius: 3px;"
        >{{$util2.getLevelInfo(grade,level)}}</span>
      </transition>
    </div>
    <img :src="require('../assets/imgs/'+ grade +'/medal1.png')" alt id="level-card-medal" />
    <span v-if="level!=='Try Harder'&&level!=='A+'" id="level-card-text">{{level}}</span>
    <span v-if="level==='A+'" id="level-card-text" style="font-size: 3rem;top: 2.5rem;">{{level}}</span>
    <span
      v-if="level==='Try Harder'"
      id="level-card-text"
      style="font-size: 1em;top: 3.8rem;"
    >{{level}}</span>
    <BeyondCard
      :name="name"
      :beyond="beyond"
      :beyondIndex="beyondIndex"
      :test-date="testDate"
      :test-inner="testInner"
      :grade="grade"
    ></BeyondCard>
  </div>
</template>
<script>
import BeyondCard from "@/common/BeyondCard";
export default {
  name: "LevelCard",
  components: {
    BeyondCard
  },
  props: {
    name: {},
    level: {},
    beyond: {
      type: Number,
      default: 1
    },
    beyondIndex: {
      type: Number,
      default: 1
    },
    levelContent: {},
    testDate: {},
    testInner: {},
    grade: {
      default: 6
    }
  },
  data() {
    return {
      showInfo: false
    };
  },
  mounted() {
    // this.getImgBorderSize();
  },
  methods: {
    showLevelInfo() {
      console.log("clickInfo");
      console.log("showInfo");
      this.showInfo = true;
      setTimeout(() => {
        console.log("closeInfo");
        this.showInfo = false;
      }, 2000);
    }
  }
};
</script>
<style lang="scss" scoped>
#level-card {
  width: 100%;
  height: 1800px;
  position: relative;
  background: #fff;
  > #level-card-banner {
    position: absolute;
    top: 0;
    width: 100%;
  }
  > #level-card-medal {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 800px;
    z-index: 20;
  }
  > #level-card-text {
    z-index: 30;
    font-size: 4rem;
    font-weight: bold;
    position: absolute;
    top: 150px;
    left: 50.1%;
    transform: translateX(-50%);
    color: #fff;
    text-shadow: 1px 1px 2px #ef9305;
  }
  .clickMask {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 50;
    width: 800px;
    height: 800px;
  }
  .infoicon {
    z-index: 40;
    position: absolute;
    top: 5.7rem;
    width: 100%;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LevelCard.vue